import global from '../global'

export default ({
	getLocation () {
		return new Promise((resolve, reject) => {
			global.$ajax({
				method: 'GET',
				dataType: 'json',
				url: '/app/locations/show/' + global.getLocation(),
				success (response) {
					resolve(response)
				},
				error (error) {
					reject(error)
				}
			}, true)
		})
	},
	getLocationHours () {
		return new Promise((resolve, reject) => {
			global.$ajax({
				method: 'GET',
				dataType: 'json',
				url: '/app/hours/' + global.getLocation(),
				success (response) {
					resolve(response)
				},
				error (error) {
					reject(error)
				}
			}, true)
		})
	}
})



// WEBPACK FOOTER //
// ./src/controllers/Location.js